import { api } from '@/lib/api/client'
import type {
  NotificationBulkResponse,
  NotificationEmptyTrashResponse,
  NotificationItem,
  NotificationListingStatus,
  NotificationOverviewResponse,
  NotificationPurgeResponse,
} from './types'

/** Sino: as `new` inteiras + contadores dos 4 status. */
export async function fetchNotificationsOverview(): Promise<NotificationOverviewResponse> {
  const { data } = await api.get<NotificationOverviewResponse>('/notifications')
  return data
}

export interface FetchByStatusParams {
  status: NotificationListingStatus
  /** epoch em segundos */
  start?: number
  /** epoch em segundos */
  end?: number
}

/** Listagem por status (`new` não é aceito aqui — só via overview). */
export async function fetchNotificationsByStatus({
  status,
  start,
  end,
}: FetchByStatusParams): Promise<NotificationItem[]> {
  const params: Record<string, string | number> = { status }
  if (start !== undefined) params.start = start
  if (end !== undefined) params.end = end
  const { data } = await api.get<NotificationItem[]>('/notifications', { params })
  return data
}

export async function markNotificationsRead(ids: string[]): Promise<NotificationBulkResponse> {
  const { data } = await api.post<NotificationBulkResponse>('/notifications/read', { ids })
  return data
}

/** Soft-delete: move pra lixeira (reversível via `restoreNotifications`). */
export async function deleteNotifications(ids: string[]): Promise<NotificationBulkResponse> {
  const { data } = await api.post<NotificationBulkResponse>('/notifications/delete', { ids })
  return data
}

export async function restoreNotifications(ids: string[]): Promise<NotificationBulkResponse> {
  const { data } = await api.post<NotificationBulkResponse>('/notifications/restore', { ids })
  return data
}

/** Hard-delete per-user: só afeta ids que estão na lixeira. */
export async function purgeNotifications(ids: string[]): Promise<NotificationPurgeResponse> {
  const { data } = await api.post<NotificationPurgeResponse>('/notifications/purge', { ids })
  return data
}

export async function emptyTrash(): Promise<NotificationEmptyTrashResponse> {
  const { data } = await api.post<NotificationEmptyTrashResponse>('/notifications/trash/empty')
  return data
}
